export const normalizeBasePath = (basePath?: string) => {
  if (!basePath) {
    return '';
  }
  const normalized = `/${basePath.replace(/^\/+|\/+$/g, '')}`;
  return normalized === '/' ? '' : normalized;
};

let shellBasePath = '';

export const registerShellBasePath = (basePath?: string) => {
  const previousBasePath = shellBasePath;
  shellBasePath = normalizeBasePath(basePath);
  return () => {
    shellBasePath = previousBasePath;
  };
};

export const getShellBasePath = () => shellBasePath;

export const parsesAsPathSuffix = (origin: string, path: string): boolean => {
  try {
    // Prefixing can make markdown junk or data:/tel: hrefs parse, so check the
    // unprefixed path to preserve the fallback that returns it untouched.
    new URL(origin + path);
    return true;
  } catch {
    return false;
  }
};

export const hasPathPrefix = (path: string, prefix: string) =>
  path === prefix || path.startsWith(`${prefix}/`);

export const joinPath = (prefix: string, path: string) =>
  `${prefix}${path.startsWith('/') ? path : `/${path}`}`;
